import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-chat-message-loading',
    templateUrl: './chat-message-loading.html',
    styleUrls: ['./chat-message-loading.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatMessageLoading {

}
